<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedications">
<h1 style="padding-bottom:10px;">Dedications</h1>
<p style="text-align: center;"><em>She Howled</em> is dedicated to my three little birds:</p><br/>
<p style="text-align: center;">Lilly, Jacqueline, and Hailey.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?ab565dea